export default {
  v3OfficialTopUpCenterTitle: 'الموقع الرسمي لمركز الشحن',
  v3OfficialTopUpCenterKeyword: 'الموقع الرسمي لمركز الشحن',
  v3OfficialTopUpCenterDescription: 'الموقع الرسمي لمركز الشحن',
  v3SafeAndFast: 'دفع آمن، خالي من المخاطر وسريع',
  v3Shop: 'المتجر',
  v3ShoppingCart: 'عربة التسوق',
  v3MembershipCenter: 'مركز الفوائد (مركز العضوية المميزة)',
  v3Login: 'تسجيل الدخول',
  v3Account: 'الحساب',
  v3EnterAccountName: 'الرجاء إدخال اسم الحساب',
  v3Password: 'كلمة السر',
  v3EnterPassword: 'يرجى إدخال كلمة السر',
  v3ForgotPassword: 'نسيت كلمة السر',
  v3EnterUID: 'يرجى إدخال الـUID',
  v3OTP: 'OTP',
  v3EnterOTP: 'الرجاء إدخال رمز OTP',
  v3SelectTopUpCharacter: 'حدد الشخصية المراد الشحن لها',
  v3SelectServer: 'يرجى اختيار الخادم',
  v3Confirm: 'تأكيد',
  v3CharacterNotFound:
    'إذا لم تتمكن من العثور على الشخصية، يرجى محاولة تسجيل الدخول إلى الشخصية في تطبيق اللعبة أولاً ثم تسجيل الدخول إلى صفحة الشحن، أو الاتصال بخدمة العملاء',
  v3Logout: 'تسجيل الخروج',
  v3SwitchAccount: 'تبديل الحساب',
  v3MyCoupons: 'قسائم التخفيض',
  v3BenefitsCenter: 'مركز الفوائد',
  v3TopUpBenefits: 'فوائد الشحن',
  v3MoreSettings: 'المزيد من الإعدادات',
  v3RememberLoginStatus: 'تذكر حالة تسجيل الدخول',
  v3OrderQuery: 'الاستعلام عن الطلبية',
  v3ContactCustomerService: 'تواصل مع خدمة العملاء',
  v3LoginWithApp: 'تسجيل الدخول باستخدام التطبيق',
  v3ChooseOtherLoginMethod: 'اختيار طريقة تسجيل دخول أخرى',
  v3ConnectingToGameApp: 'جارِ الاتصال بتطبيق اللعبة',
  v3EnsureGameInstalled:
    'يرجى التأكد من تثبيت اللعبة على الجهاز. إذا كانت اللعبة لا تستجيب أو فشل تسجيل الدخول، فيرجى ترقية اللعبة إلى أحدث إصدار من متجر التطبيقات أو التغيير إلى متصفح آخر.',
  v3OpenGame: 'افتح اللعبة',
  v3DownloadGame: 'تحميل اللعبة',
  v3UpdateGameIfOpenFails:
    'إذا فشل فتح اللعبة، فيرجى ترقية اللعبة إلى أحدث إصدار من متجر التطبيقات',
  v3ClickToDownloadLatestVersion:
    'أو انقر فوق زر تنزيل اللعبة لتنزيل أحدث إصدار',
  v3LoggingIntoOfficialTopUpCenter:
    'أنت تقوم بتسجيل الدخول إلى [مركز الشحن الرسمي]',
  v3CurrentAccount: 'الحساب الحالي: xxxxxxxxxxxx',
  v3WelcomeToOfficialTopUpCenter: 'مرحبا بكم في الموقع الرسمي لمركز الشحن',
  v3OfficialAuthorizedLogin: 'تسجيل دخول معتمد رسميًا، آمن وخالي من المخاطر',
  v3TermsOfService: 'شروط الخدمة',
  v3PrivacyPolicy: 'سياسة الخصوصية',
  v3ThirdPartySocialAccountDescription:
    'تعليمات حسابات مواقع التواصل الاجتماعي (الطرف الثالث)',
  v3BindSocialAccountInGameFirst:
    'يُرجى أولاً إكمال ربط حسابات مواقع التواصل الاجتماعي في مركز المستخدم داخل اللعبة، ثم استخدامها لتسجيل الدخول.',
  v3FirstTopUp15PercentOff: 'استمتع بخصم يصل إلى 15% عند الشحن لأول مرة',
  v3MoreTopUpRebates: 'سيتم إرسال المزيد من خصومات الشحن دون توقف',
  v3LoginToViewOffers: 'سجّل الدخول لمشاهدة العروض',
  v3TopUpEnvironmentChecking: 'يتم الآن اختبار بيئة الشحن...',
  v3SafeToUse: 'آمن، ويمكن استخدامه بثقة',
  v3LimitedTimeBenefits: 'فوائد لفترة محدودة',
  v3EventRules: 'قواعد النشاط',
  v3MoreEvents: 'المزيد من الأنشطة',
  v3Claim: 'استلام',
  v3Completed: 'مكتمل',
  v3GoTo: 'توجّه',
  v3ViewDetails: 'تحقق من التفاصيل',
  v3RecommendedProducts: 'المنتجات الموصى بها',
  v3SearchProductName: 'بحث باسم المنتج',
  v3AllCategories: 'جميع الفئات',
  v3PopularSort: 'الفرز الرائج',
  v3PriceAscending: 'ترتيب تصاعدي للسعر',
  v3PriceDescending: 'ترتيب تنازلي للسعر',
  v3DiamondBonus10Percent: 'الماس إضافي 10%',
  v3YuanbaoBonus10Percent: 'ذهب إضافي 10%',
  v3ExtraBonus10Percent: 'مكافأة إضافية 10%',
  v3FirstTopUpDouble: 'مضاعفة الشحنة الأولى',
  v3FirstExtraBonus: 'مكافأة إضافية للمرة الأولى',
  v3ProductDetails: 'تفاصيل المنتج',
  v3AddToCart: 'أضف إلى العربة',
  v3AddedToCart: 'تمت إضافته إلى سلة التسوق',
  v3BuyNow: 'اشتر الآن',
  v3NoItemsInCart: 'لم تقم بشراء أي عناصر في سلة التسوق الخاصة بك حتى الآن',
  v3SelectedItemsN: 'المنتجات المختارة (${n})',
  v3RemoveFromCart: 'هل تريد إزالة عربة التسوق',
  v3Yes: 'نعم',
  v3No: 'لا',
  v3LimitOnePerPurchase: 'يقتصر هذا المنتج على عملية شراء واحدة في كل مرة',
  v3ItemPrice: 'سعر المنتج',
  v3Tax: 'الضريبة',
  v3ExtraGift: 'الهدية الإضافية',
  v3Total: 'المجموع',
  v3ProceedToPayment: 'اذهب للدفع',
  v3SelectCoupon: 'حدد القسيمة',
  v3UnavailableCoupons: 'القسيمة غير متوفرة',
  v3OneCouponPerOrder: 'حد واحد لكل طلبية',
  v3DiscountCoupon: 'قسيمة الخصم',
  v3ThresholdCoupon: 'قسائم التخفيض عن الإكمال',
  v3MinSpendCoupon: 'متوفر بحد أدنى xx USD',
  v3MaxDiscountCoupon: 'الحد الأقصى للخصم xxxx USD',
  v3LimitedChannel: 'متاحة لقنوات محدودة',
  v3AllChannels: 'متاحة لجميع القنوات',
  v3SpecificProducts: 'متوفرة لمنتجات مختارة',
  v3AllProducts: 'متاحة لجميع العناصر',
  v3NotYetTimeToUse: 'ليست في وقت الاستخدام',
  v3Expired: 'منتهي الصلاحية',
  v3Used: 'تم الاستخدام',
  v3ValidityPeriod: 'فترة الصلاحية:',
  v3ConfirmUse: 'تأكيد الاستخدام',
  v3ChangeProduct: 'تغيير المنتج',
  v3ConfirmPaymentOrder: 'تأكيد دفع الطلبية',
  v3StoredValueRole: 'شخصية الشحن',
  v3TotalNProducts: 'إجمالي ${n} منتجات',
  v3SelectPaymentMethod: 'اختر طريقة الدفع',
  v3PayNow: 'ادفع الآن',
  v3MorePaymentMethods: 'المزيد من طرق الدفع',
  v3NoAvailablePaymentMethodContactSupport:
    'لا يمكنك العثور على طريقة دفع ممكنة؟ اتصل بخدمة العملاء',
  v3AvailableCoupons: 'القسائم المتاحة',
  v3Extra10Percent: 'زيادة 10%',
  v3LastSelection: 'آخر اختيار',
  v3RecommendedUsage: 'مقترح',
  v3PopularChoice: 'الخيارات الرائجة',
  v3PaymentSuccess: 'تم الدفع بنجاح',
  v3PaymentFailure: 'فشل الدفع',
  v3TopUpFailureMessage:
    'نأسف جدًا لفشل عملية الشحن، يرجى محاولة إعادة إرسال الطلب أو الاتصال بنا من خلال زر خدمة العملاء أدناه.',
  v3Game: 'اللعبة',
  v3UID: 'UID',
  v3OrderNumber: 'رقم الطلبية',
  v3ProductContent: 'محتوى المنتج',
  v3ViewProductDetails: 'عرض تفاصيل المنتج',
  v3PaymentMethod: 'طريقة الدفع',
  v3Complete: 'انتهى',
  v3TopUpAgain: 'شحن مبلغ آخر',
  v3FriendlyReminderSaveOrderInfo:
    'تذكير: التقط لقطة شاشة لحفظ معلومات الطلب حتى نتمكن من معالجة طلبك بسرعة.',
  v3RechargeAgain: 'الشحن مجددًا',
  v3TransactionInProgress: 'المعاملة قيد التنفيذ',
  v3CompletePaymentInChannel: 'يرجى الانتقال إلى قناة الدفع لإكمال دفع الطلب',
  v3RestAssuredFastDeliveryAfterPayment:
    'لا تقلق، عندما نتلقى نتيجة دفع الطلب، سنصدر لك عناصر المنتج في أسرع وقت ممكن.',
  v3SaveOrderInfoForProgress:
    'يمكنك التقاط لقطة شاشة لحفظ معلومات الطلب لتأكيد تقدم المعاملة',
  v3PaymentCompleted: 'لقد أكملت الدفع',
  v3AddToHomeScreen: 'أضف إلى الشاشة الرئيسية',
  v3AddShortcutForBonus: 'أضف اختصارات سطح المكتب واحصل على مكافآت إضافية',
  v3ShareSuccess: 'تمت المشاركة',
  v3ShareFailure: 'فشلت المشاركة',
  v3RewardClaimed: 'تم استلام المكافأة',
  v3RewardClaimFailed: 'فشل استلام الجائزة',
  v3EventNotStarted: 'الحدث لم يبدأ',
  v3EventEnded: 'انتهى الحدث',
  v3ClickSelectCoupon: 'انقر لاختيار القسيمة',
  v3CouponsRecommendedUsed: 'تم استخدام القسيمة الموصى بها',
  v3CouponsSelected: 'القسيمة المختارة',
  v3NoCouponsAvaliable: 'لا توجد قسائم متاحة',
  v3SupplementStatus: 'الحالة',
  v3SupplementNormal: 'طبيعي',
  v3SupplementBanned: 'محظور',
  v3SupplementPendingPayment: 'في انتظار الدفع',
  v3SupplementSwitchCharacter: 'تبديل الشخصية',
  v3SupplementAccountInfoInvalid: 'معلومات الحساب غير صالحة',
  v3SupplementContactGSForTopUpLink: 'يرجى الاتصال بـ GS للحصول على رابط الشحن',
  v3SupplementTopUpCompleted: 'تم إكمال الشحن:',
  v3SupplementTotalRefundOrders: 'إجمالي طلبات الاسترداد {}',
  v3SupplementPendingSupplementAmount: 'مبلغ الدفع المعلق',
  v3SupplementAccountCharacterNormalNoPaymentNeeded:
    'الحساب/الشخصية طبيعي، لا حاجة للدفع',
  v3SupplementEnjoyYourGame: 'استمتع بلعبتك!!',
  v3SupplementOrderInformation: 'معلومات الطلب',
  v3SupplementPendingPaymentAmount: 'المبلغ المستحق',
  v3LookUpCouponRule: 'عرض قواعد توزيع القسائم',
  v3SwitchOldVersion: 'تحويل للإصدار القديم من منصة الدفع',
  v3FirstTopUpGiveaway: 'هدية الشحن الأول',
  v3SecureConnection: 'جارٍ القيام بالاتصال الآمن',
  v3RequestTimeOut: 'انتهت مهلة التحميل، يرجى المحاولة لاحقاً',
  v3ConfirmLeave: 'تأكيد المغادرة؟',
  v3NoSubmitOrder:
    'لم تقم بتسوية عربة التسوق الخاصة بك بعد، قد تفوتك المنتجات المفضلة إذا غادرت!',
  v3ContinueSubmit: 'متابعة الشراء',
  v3LeaveSubmit: 'مغادرة',
  v3RecentBug: 'المشتريات الأخيرة',
  v3PwaTapShareOrMenuIcon: 'انقر فوق رمز المشاركة أو القائمة في شريط أدوات المتصفح',
  v3PwaFindAndTapAddToHomeScreen: 'ابحث عن "إضافة إلى الشاشة الرئيسية" وانقر عليها في الخيارات'
};
